import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { log } from '@shared/lib/helpers/debugLog'
import type {
  TypeMappingRestOutput as MappedRestaurant,
  TypeMappingRestTag as MappedRestaurantTag,
} from '@shared/api/middleware/mappingAPI/restaurant/type'
import { appHomeInitialState } from '@pages/AppHome/model/initialState'
import type { TypeMappingNewsOutput as MappedNews } from '@shared/api/middleware/mappingAPI/news/type'
import type { TypeMappingSelectionOutput as MappedSelection } from '@shared/api/middleware/mappingAPI/selection/type'
import type { TypeQuickFilter as QuickFilter } from '@shared/api/middleware/mappingAPI/city/types'
import type { NullableListPayload } from '@shared/types/redux'

const appHome = createSlice({
  name: 'appHome',
  initialState: appHomeInitialState,

  reducers: {
    setFeatureRests(state, action: PayloadAction<NullableListPayload<MappedRestaurant>>) {
      const payload = action.payload || null
      log('app_home slice', 'setFeatureRests', { count: payload?.length ?? 0 })
      state.sections.featureRests.loading = false
      state.sections.featureRests.list = payload
    },
    setQuickFilters(state, action: PayloadAction<NullableListPayload<QuickFilter>>) {
      state.sections.quickFilters.loading = false
      state.sections.quickFilters.list = action.payload || null
    },
    setTags(state, action: PayloadAction<NullableListPayload<MappedRestaurantTag>>) {
      state.sections.tags.loading = false
      state.sections.tags.list = action.payload || null
    },

    setSpecialRests(state, action: PayloadAction<NullableListPayload<MappedRestaurant>>) {
      state.sections.specialRests.loading = false
      state.sections.specialRests.list = action.payload || null
    },

    setDeliveryKuperRests(state, action: PayloadAction<NullableListPayload<MappedRestaurant>>) {
      state.sections.deliveryKuperRests.loading = false
      state.sections.deliveryKuperRests.list = action.payload || null
    },

    setRatingRests(state, action: PayloadAction<NullableListPayload<MappedRestaurant>>) {
      state.sections.ratingRests.loading = false
      state.sections.ratingRests.list = action.payload || null
    },
    setBookingRests(state, action: PayloadAction<NullableListPayload<MappedRestaurant>>) {
      state.sections.bookingRests.loading = false
      state.sections.bookingRests.list = action.payload || null
    },

    setAfishaSelections(state, action: PayloadAction<NullableListPayload<MappedSelection>>) {
      state.sections.afishaSelections.loading = false
      state.sections.afishaSelections.list = action.payload || null
    },

    setRestaurantsNews(state, action: PayloadAction<NullableListPayload<MappedNews>>) {
      state.sections.restaurantsNews.loading = false
      state.sections.restaurantsNews.list = action.payload || null
    },

    setInterviews(state, action: PayloadAction<NullableListPayload<MappedNews>>) {
      state.sections.interviews.loading = false
      state.sections.interviews.list = action.payload || null
    },

    setOtherNews(state, action: PayloadAction<NullableListPayload<MappedNews>>) {
      state.sections.otherNews.loading = false
      state.sections.otherNews.list = action.payload || null
    },

    setWeekPlans(state, action: PayloadAction<MappedNews | null | undefined>) {
      state.sections.weekPlans.loading = false
      state.sections.weekPlans.data = action.payload || null
    },

    resetState() {
      return appHomeInitialState
    },
  },
})

export const {
  setFeatureRests,
  setQuickFilters,
  setTags,
  setSpecialRests,
  setDeliveryKuperRests,
  setRatingRests,
  setBookingRests,
  setAfishaSelections,
  setRestaurantsNews,
  setOtherNews,
  setWeekPlans,
  resetState,
  setInterviews,
} = appHome.actions

export default appHome.reducer
